import _ from 'underscore';
import { mapState } from 'vuex';
import f from '@/application/shared/functions.js'

export default {
	name: 'moderation_preivew',
	props: {
		task : Object
	},

	components : {
		
	},

	data : function(){

		return {}

	},

	created() {
		
	},

	destroyed() {
	},

	watch: {
		
	},
	computed: mapState({
		
		auth : state => state.auth,
		
	}),

	methods : {

		showModerationData : function(){
			

			this.core.vueapi.taskdata({
				uid : this.task.uid
			}, {
				changed : () => {
					this.$emit('changed')
				}
			})
		}
		
	},
}